import { Box, Container, Typography } from "@mui/material"
import { useEffect } from "react"

const PrivacyPolicy = () => {
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	return (
		<Container maxWidth="md" sx={{ my: 5 }}>
			<Typography variant="h4" gutterBottom>
				Privacy Policy
			</Typography>

			<Typography variant="body1" paragraph>
				Spyware Computer (OPC) Pvt. Ltd. ("Spyware Computers", "we", "us", "our") operates this website, its authorized franchise study centers, and the associated student, franchise, and admin panels. This Privacy Policy explains what information we collect, how we use it, and the choices you have, whether you are a visitor, a prospective student, an enrolled student, or a franchise partner.
			</Typography>

			{/* Section 1 */}
			<Typography variant="h6" gutterBottom>
				1. Information We Collect
			</Typography>
			<Typography variant="body1" paragraph>
				1.1 <strong>Admission &amp; Student Records</strong> — when you enroll in a course, we collect your name, guardian/parent name, mother's name, date of birth, gender, mobile number, email, postal address, Aadhaar number, photograph, academic/educational background, and the course, batch, and franchise center you are enrolled with.
			</Typography>
			<Typography variant="body1" paragraph>
				1.2 <strong>Enquiry, Admission &amp; Workshop Forms</strong> — when you submit an enquiry, apply for admission, or register for a workshop through our website, we collect your name, mobile number, email, gender, date of birth, meal preference (for workshops), and the course or program you are interested in.
			</Typography>
			<Typography variant="body1" paragraph>
				1.3 <strong>Academic &amp; Attendance Records</strong> — subject-wise marks, exam results, grades, attendance records (including QR-based attendance scans and ID card data), homework submissions, and certificates/marksheets issued to you.
			</Typography>
			<Typography variant="body1" paragraph>
				1.4 <strong>Payment Information</strong> — course fee payment records and receipts processed by your franchise center. We do not store your card, UPI PIN, or net-banking credentials.
			</Typography>
			<Typography variant="body1" paragraph>
				1.5 <strong>Account &amp; Login Data</strong> — login credentials and session cookies for the student, franchise, and admin panels, used to keep you signed in securely.
			</Typography>
			<Typography variant="body1" paragraph>
				1.6 <strong>Reviews, Gallery &amp; Public Content</strong> — testimonials/reviews you submit, and photographs/videos captured during events, workshops, or at our centers that may be published on our website or gallery.
			</Typography>

			{/* Section 2 */}
			<Typography variant="h6" gutterBottom>
				2. How We Use Your Information
			</Typography>
			<Typography variant="body1" paragraph>
				2.1 To process admissions, manage enrollment, and deliver course content, homework, and assessments.
			</Typography>
			<Typography variant="body1" paragraph>
				2.2 To track attendance, record academic performance, and issue marksheets, certificates, and ID cards.
			</Typography>
			<Typography variant="body1" paragraph>
				2.3 To process fee payments and maintain payment/receipt records.
			</Typography>
			<Typography variant="body1" paragraph>
				2.4 To respond to enquiries, admission requests, and workshop registrations.
			</Typography>
			<Typography variant="body1" paragraph>
				2.5 To verify issued certificates and marksheets when requested through our public verification tools.
			</Typography>
			<Typography variant="body1" paragraph>
				2.6 To communicate important updates regarding your course, batch, fees, or center via SMS, WhatsApp, email, or phone.
			</Typography>
			<Typography variant="body1" paragraph>
				2.7 To showcase student achievements, reviews, and event photographs/videos on our website and social media, where consent has been given.
			</Typography>

			{/* Section 3 */}
			<Typography variant="h6" gutterBottom>
				3. Sharing of Information
			</Typography>
			<Typography variant="body1" paragraph>
				3.1 Your information is shared with the specific authorized franchise study center where you are enrolled, so they can manage your admission, attendance, academics, and fees.
			</Typography>
			<Typography variant="body1" paragraph>
				3.2 We do not sell your personal information to third parties.
			</Typography>
			<Typography variant="body1" paragraph>
				3.3 We may disclose information where required by law, to government authorities, or to protect the rights, property, or safety of Spyware Computer (OPC) Pvt. Ltd., our students, or the public.
			</Typography>

			{/* Section 4 */}
			<Typography variant="h6" gutterBottom>
				4. Cookies
			</Typography>
			<Typography variant="body1" paragraph>
				4.1 We use cookies to keep you signed in to the student, franchise, and admin panels and to remember your session.
			</Typography>
			<Typography variant="body1" paragraph>
				4.2 You can disable cookies through your browser settings, but doing so may prevent you from logging in or using certain features of this website.
			</Typography>

			{/* Section 5 */}
			<Typography variant="h6" gutterBottom>
				5. Data Security
			</Typography>
			<Typography variant="body1" paragraph>
				5.1 We take reasonable technical and organizational measures to protect your personal information from unauthorized access, alteration, or disclosure.
			</Typography>
			<Typography variant="body1" paragraph>
				5.2 Access to student records within our panels is restricted to authorized franchise and admin staff on a need-to-know basis.
			</Typography>

			{/* Section 6 */}
			<Typography variant="h6" gutterBottom>
				6. Data Retention
			</Typography>
			<Typography variant="body1" paragraph>
				6.1 We retain student academic, attendance, and certificate records for as long as necessary to issue certificates, respond to verification requests, and comply with our record-keeping obligations.
			</Typography>

			{/* Section 7 */}
			<Typography variant="h6" gutterBottom>
				7. Children's Privacy
			</Typography>
			<Typography variant="body1" paragraph>
				7.1 Some of our students may be minors. Where a student is a minor, admission information is provided and consented to by a parent or guardian on the student's behalf.
			</Typography>

			{/* Section 8 */}
			<Typography variant="h6" gutterBottom>
				8. Your Choices
			</Typography>
			<Typography variant="body1" paragraph>
				8.1 You may contact us or your franchise center to review, correct, or request deletion of your personal information, subject to our legal and record-keeping obligations (for example, issued certificates and academic records).
			</Typography>

			{/* Section 9 */}
			<Typography variant="h6" gutterBottom>
				9. Changes to This Policy
			</Typography>
			<Typography variant="body1" paragraph>
				9.1 We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised effective date.
			</Typography>

			{/* Final Notes */}
			<Box mt={4}>
				<Typography variant="body1" paragraph>
					By using this website or enrolling at Spyware Computer Education, you acknowledge that you have read and understood this Privacy Policy.
				</Typography>
				<Typography variant="body1">For any privacy-related queries or requests, please contact us at:</Typography>
				<Typography variant="body2" mt={2}>
					Spyware Computer (OPC) Pvt. Ltd.
					<br />
					Mirchaibari Road, Katihar - 854105, Bihar, India
					<br />
					info@spywarecomputers.com
					<br />
					+91 7808426759
				</Typography>
			</Box>
		</Container>
	)
}

export default PrivacyPolicy
